import React, { Component } from 'react';
import { connect } from "react-redux";
import * as playlistActions from "../../actions/playlist";
import {withRouter} from 'react-router';
import * as vignetsActions from "../../actions/vignets";
import QRCode from 'qrcode.react';
import AuthService from "../../lib/AuthService";
import { Modal, ModalBody, ModalFooter, Button, Collapse} from 'reactstrap';


class VignetItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            backtoPlaylist : false,
            showDuplicatedPlaylist : false,
            image_path: null,
            detUrl : false,
            items : [],
            showPreview : false,
            showshareModal : false,
            showVigOptions : false,
            QrUrl : ''

        };

        this.Auth = new AuthService();

        this.csToggle = this.csToggle.bind(this);
        this.confirmRemove =this.confirmRemove.bind(this);
        this.removeFromPlaylist=this.removeFromPlaylist.bind(this);
        this.showSharePop = this.showSharePop.bind(this);
        this.mToggle = this.mToggle.bind(this);
        this.qToggle = this.qToggle.bind(this);
        this.cToggle = this.cToggle.bind(this);
        this.dToggle = this.dToggle.bind(this);
        this.rToggle = this.rToggle.bind(this);
        this.pToggle = this.pToggle.bind(this);
        this.sToggle = this.sToggle.bind(this);
        this.shareToFb = this.shareToFb.bind(this);
        this.showWebModal = this.showWebModal.bind(this);
        this.showQRModal = this.showQRModal.bind(this);
        this.downloadQRCode = this.downloadQRCode.bind(this);
        this.showPreviewModal = this.showPreviewModal.bind(this);
        this.handleVignet = this.handleVignet.bind(this);
        this.setQrUrl = this.setQrUrl.bind(this);

    }

    componentWillMount() {

        //document.getElementsByClassName("modal-backdrop").style.display = 'none';
    }

    componentDidMount() {
        this.setPlayerUrl();
    }


    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.playlistItem !== prevProps.playlistItem) {
            this.setPlayerUrl();
            this.setQrUrl();
        }

    }

    setPlayerUrl() {
        let vignet = this.props.playlistItem;
        let playerUrl = '';
        if(vignet.public_view === 1) {
            playerUrl = this.props.pageSettingsData.config.PUB_PLAYER_PATH+ vignet.vignet_id;
        }
        else{
            playerUrl = this.props.pageSettingsData.config.UNPUB_PLAYER_PATH+ vignet.vignet_id+'//';
        }
        this.setState({playerUrl : playerUrl});
    }
    setQrUrl() {
        let vignet = this.props.playlistItem;
       let QrUrl = this.props.pageSettingsData.config.PUB_PLAYER_PATH+ vignet.vignet_id;
        this.setState({QrUrl : QrUrl});
    }

    removeFromPlaylist() {
        let data = {plid : this.props.playlistData.playlistId, vigid : this.state.vignetId}
        this.props.removeFromPlaylist(data);
        this.setState({showConfirmRemove : false});
    }


    csToggle() {
        this.setState({showConfirmSimilar : !this.state.showConfirmSimilar});
    }

    dToggle() {
        this.setState({showConfirmDelete : !this.state.showConfirmDelete})
    }

    rToggle() {
        this.setState({showConfirmRemove : !this.state.showConfirmRemove})
    }

    confirmRemove(vignetId){
        this.setState({showConfirmRemove : true,
            vignetId :vignetId})
    }

    showSharePop(vignet_id) {
        this.setState({showshareModal : !this.state.showshareModal, vignet_id : vignet_id})
    }

    mToggle() {
        console.log(this.state.showPop);
        this.setState({
            showPop: !this.state.showPop
        });
    }

    cToggle() {
        this.setState({
            copyUrl: !this.state.copyUrl
        });
    }

    qToggle() {
        console.log(this.state.showQR);
        this.setState({
            showQR: !this.state.showQR
        });
    }
    sToggle() {
        console.log(this.state.showshareModal);
        this.setState({
            showshareModal: !this.state.showshareModal
        });
    }


    /*********** Copy the web url to share among users ********/
    showWebModal(vigID)
    {
        var uid= this.Auth.getProfile().user_id;

        var e = document.createElement("textarea");
      //  var url ="https://a.vignets.com/react-vignet/player/?"+vigID+'/'+uid ;
        var url = this.state.playerUrl+'/'+uid ;
        e.value = String(url);
        document.body.appendChild(e);
        e.select();
        document.execCommand("copy");
        document.body.removeChild(e);

        this.setState({
            copyUrl : url
        });

    }

    shareToFb(type, vignet_id, vignet_title) {

     //   var baseUrl =String('https://agency.vignets.com/player//'+vignet_id);
        var baseUrl =String(this.state.playerUrl);
        let rootUrl = '';let shareUrl ='';


        if(type === 'fb') {
            /******************* Fb Share**************/
            let rootUrl = baseUrl + "//fb";
            shareUrl = "http://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(rootUrl);
        }
        else if(type === 'wa') {
            /******************* Whatsapp Share**************/
            rootUrl = baseUrl + "//wa";
            shareUrl = "https://api.whatsapp.com/send?text=" + rootUrl;
        }
        else if(type === 'em') {
            /******************* Email Share************/
            rootUrl = baseUrl + "//em";
            shareUrl = "mailto:?subject=" + vignet_title + "&body=" + rootUrl;
        }
        window.open(shareUrl,'_blank',"toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=600,height=400");

        // this.setState({
        //     shareUrl : shareUrl
        // }, function() {
        //     window.open(shareUrl,'_blank',"toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=600,height=400");
        // });
    }

    /*********** Scan QR code of vignet********/
    showQRModal(vigID)
    {
        this.setState({
            showQR : true
        });

    }

    downloadQRCode() {
        let vignet_id = this.state.vignetId;
        var canvas = document.querySelector( 'canvas' );
        var link = document.createElement('a');
        link.innerHTML = 'Download';
        link.addEventListener('click', function(ev) {
            link.href = canvas.toDataURL();
            link.download = vignet_id+".png";
        }, false);
        document.body.appendChild(link);
        link.click();
    }


    addToPlaylist() {
        console.log(this.props.playlistData);
        this.props.loadVignets();
        let data = {plid :  this.props.match.params.id , vigids : this.props.vignetsData.selected_ids}
        this.props.addItemToPlaylist(data);
        this.vToggle();

    }

    showPreviewModal(public_view,vignet_id,user_id ){
        let playerUrl = "";
        if(public_view === 1) {
            playerUrl = this.props.pageSettingsData.config.PUB_PLAYER_PATH+ vignet_id;
        }
        else{
            playerUrl = this.props.pageSettingsData.config.UNPUB_PLAYER_PATH+ vignet_id+'/'+user_id+'//';
        }
        this.setState({
            showPreview : true,
            playerUrl :playerUrl
        });
    }
    pToggle() {
        this.setState({showPreview : !this.state.showPreview})
    }

    handleVignet() {
        this.setState({showVigOptions : !this.state.showVigOptions})
    }



    render() {

        let item = this.props.playlistItem;

        let imgSrc = this.props.pageSettingsData.config.IMGIX_PATH+'assets/slider/cf'+item.vignet_id+'.jpg';

        if(item.public_view === 1) {
            item.playerUrl = this.props.pageSettingsData.config.PUB_PLAYER_PATH+ item.vignet_id;
        }
        else{
            item.playerUrl = this.props.pageSettingsData.config.UNPUB_PLAYER_PATH+ item.vignet_id+'//';
        }


        return (

            <tr>
                <td>
                    <div className="report-img">
                        <img src={imgSrc} alt={imgSrc}/>
                    </div>
                    {item.vignet_title}
                    <div className="toggles-block">
                        <button className="toggle-ico"
                                onClick={() => this.handleVignet()}
                                aria-controls="collapse-vig-options"
                                aria-expanded={this.state.showVigOptions}></button>

                        <Collapse isOpen={this.state.showVigOptions}>

                            <ul id="collapse-vig-options" className="toggle-flip">
                                <li id={"vig-upload" + item.vignet_id}>
                                    <a href="javascript:;" className="icon-lib side-arrow vig-share"
                                       onClick={() => this.showSharePop()}
                                       aria-controls="collapse-share-options"
                                       aria-expanded={this.state.showVigOptions}>Share</a>

                                </li>
                                <li>
                                    {/*<a href={item.playerUrl} target="_blank" className="icon-lib">Preview</a>*/}
                                    <a href="javascript:void(0);" className="icon-lib" onClick={() => {
                                        this.showPreviewModal(item.public_view, item.vignet_id, item.user_id)
                                    }}>Preview</a>
                                </li>
                                <li>
                                    <a href={'/vignet/' + item.vignet_id} target="_blank"
                                       className="icon-lib">Details</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);" className="last-row icon-lib" onClick={() => {
                                        this.confirmRemove(item.vignet_id)
                                    }}>Remove
                                        from this Playlist</a>
                                </li>
                            </ul>
                        </Collapse>
                    </div>
                    <Modal isOpen={this.state.showPreview} id="preview"  toggle={() =>this.pToggle()} centered={true} className="vig-mod modal-lg vig-modal user-md create-new-pop md-wd-mod" id="vignetModal-user" tabindex="-1" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                        <div className="modal-content-wrapper">
                            <div className="modal-header">
                                <form id="company">
                                    <button type="button" className="modal-btn-close"  data-dismiss="modal" aria-label="Close" onClick={(e) =>this.pToggle(e)} >✕</button>
                                    <h4 className="modal-title icon-lib title-icon">Preview</h4>
                                </form>
                            </div>
                            <ModalBody>
                                <iframe src={this.state.playerUrl} width='100%' height="100%"></iframe>
                            </ModalBody>

                        </div>
                    </Modal>

                    <Modal isOpen={this.state.showConfirmRemove} id="remove-playlist">
                        <ModalBody>
                            <div className="alert alert-default text-center" role="alert">
                                Do you want to remove the vignet from the playlist?
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.rToggle}>Cancel</Button>
                            <Button color="primary" onClick={this.removeFromPlaylist}>Confirm</Button>
                        </ModalFooter>
                    </Modal>

                    {this.state.copyUrl &&

                    <Modal isOpen={this.state.copyUrl} toggle={this.cToggle} >
                        <ModalBody>
                            <div className="alert alert-danger text-center" role="alert">
                                The link copied to clipboard. {this.state.copyUrl}
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.cToggle}>Close</Button>
                        </ModalFooter>
                    </Modal>
                    }

                    {this.state.showQR &&

                    <Modal isOpen={this.state.showQR} toggle={this.qToggle} className="md-width">
                        <ModalBody>
                            <div className="alert alert-default text-center" role="alert">

                                <QRCode value={this.state.QrUrl}/>

                            </div>
                            <div className="modal-adduser-content-btn">
                                <div className="modal-btn btn-cancel">
                                    <a href="javascript:void(0);" className="" onClick={this.downloadQRCode}>Download</a>
                                </div>
                                <div className="modal-btn btn-create">
                                    <a href="javascript:void(0);" onClick={this.qToggle} className="">Close</a>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                    }
                    {this.state.showshareModal &&
                    <Modal isOpen={this.state.showshareModal} toggle={this.sToggle} className="md-width share-mod">
                        <ModalBody>
                                        <ul id="collapse-share-options" className="upload">
                                            <li>
                                                <a href="javascript:void(0);" className="icon-lib icon-face"
                                                   onClick={() => {
                                                       this.shareToFb('fb', item.vignet_id)
                                                   }}>Facebook</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" className="icon-lib icon-whatsapp"
                                                   onClick={() => {
                                                       this.shareToFb('wa', item.vignet_id)
                                                   }}>Whatsapp</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" className="icon-lib icon-email"
                                                   onClick={() => {
                                                       this.shareToFb('em', item.vignet_id, item.vignet_title)
                                                   }}>Email</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" className="icon-lib icon-embed"
                                                   onClick={() => {
                                                       this.showWebModal(item.vignet_id, item.vignet_title)
                                                   }}>Copy Embed Code</a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" className="icon-lib icon-qr" onClick={() => {
                                                    this.showQRModal(item.vignet_id)
                                                }}>QR Code</a>
                                            </li>
                                        </ul>
                        </ModalBody>
                    </Modal>
                }




                </td>
            </tr>
        );
    }


}

function mapStateToProps(state) {
    return {
        playlistData  :state.playlist.playlistData,
        uploadData : state.upload.uploadData,
        vignetsData  :state.vignets.vignetsData,
        pageSettingsData  : state.pages.pageSettings
    };

}
export default  withRouter(connect(mapStateToProps, {
    removeFromPlaylist : playlistActions.removeFromPlaylist,
    duplicatePlaylist : playlistActions.duplicatePlaylist,
    getImagepurged : playlistActions.purgeImage,
    allVignetsData : vignetsActions.fetchVignetsData,
    addItemToPlaylist : playlistActions.addToPlaylist,
    selectVignets : vignetsActions.chooseVignets,
    clearVignets  : vignetsActions.clearVignets,
    loadVignets  : playlistActions.addToPlaylist,
})(VignetItem));



// WEBPACK FOOTER //
// ./src/components/playlist/VigItem.js